import * as React from "react"
import * as styles from "./styles.module.scss"

const Glossary: React.FC = () => {
  return (
    <section className={styles.glossary} data-qa="home-page-footer">
      <div className={styles.pagePadding}>
        <div className={styles.blockWrapper}>
          <div className={styles.block}>
            <h4 className={styles.heading}>Cost of roof</h4>
            <p className={styles.paragraph}>
              The estimated cost of your Solar Roof includes materials,
              installation, and the removal of your old roof. Taxes, permit fees
              and additional construction costs such as significant structural
              upgrades, gutter replacement, or skylight replacements are not
              included. The Solar Roof cost is based on estimated roof square
              footage for your home, provided by Google Project Sunroof where
              available, and the portion of your roof covered with solar tiles.
            </p>
          </div>
          <div className={styles.block}>
            <h4 className={styles.heading}>Value of energy</h4>
            <p className={styles.paragraph}>
              The value of energy your Solar Roof is expected to produce over 30
              years is based on the average price of electricity in your area,
              adjusted for inflation by 2% annually. Your ability to realize the
              full value depends on your home’s electricity usage, amount of
              energy storage available, and utility regulations on solar in your
              area. Electricity price estimates are sourced from the{"{"}" "
              {"}"}
              <a
                className={styles.link}
                href="https://www.eia.gov/electricity/monthly/epm_table_grapher.php?t=epmt_5_6_a"
                target="_blank"
              >
                <span className="bet-LinkUnderline">
                  Energy Information Administration
                </span>
              </a>
              {"{"}" "{"}"}
              and solar production estimates are based on irradiance data from
              NASA
            </p>
          </div>
          <div className={styles.block}>
            <h4 className={styles.heading}>Tax credit</h4>
            <p className={styles.paragraph}>
              The 30% Solar Investment Tax Credit applies to the cost of the
              solar tiles and associated solar energy equipment as well as the
              cost of the Powerwall batteries. To receive the full tax credit,
              you must have federal income tax liability that’s at least equal
              to the value of the tax credit. This credit may be carried over to
              future tax years. Additional state, local or utility solar
              incentives may apply but are not included in this calculation.
            </p>
          </div>
          <div className={styles.block}>
            <h4 className={styles.heading}>Loan cost</h4>
            <p className={styles.paragraph}>
              Customers can choose to finance their Solar Roof through their
              home mortgage. The loan amount is equal to the total Solar Roof
              cost, less the estimated 30% federal tax credit. The monthly loan
              payment is amortized over the selected loan term at the selected
              interest rate. Values depicted above are for illustrative purposes
              only.
            </p>
          </div>
          <div className={styles.block}>
            <h4 className={styles.heading}>Roof savings</h4>
            <p className={styles.paragraph}>
              The estimated return on investment if you invested the cost of
              roof in an S&amp;P 500 index fund for 30 years instead of paying a
              lump sum of cash.
            </p>
          </div>
          <div className={styles.block}>
            <h4 className={styles.heading}>Maximum retail loan size</h4>
            <p className={styles.paragraph}>
              The maximum retail loan is $35,000. This is based off of industry
              averages.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Glossary
